import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import * as d3 from 'd3';
import { GaugeChart } from './gauge-chart.model';

@Component({
  selector: 'app-gauge-chart',
  templateUrl: './gauge-chart.component.html',
  styleUrls: ['./gauge-chart.component.scss']
})
export class GaugeChartComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() value: any = 0;
  @Input() min: any = 0;
  @Input() max: any = 100;
  @Input() data: any = [];
  @Input() page: string = 'LandingPage';

  gaugeChart: GaugeChart;
  intervalIndex: any;
  constructor() { }

  ngOnInit() {}

  ngAfterViewInit() {
    const nameStr = '.' + this.data.name;
    const svg = d3.select(nameStr).append('svg')
      .attr('class', 'c-chart-gauge');
    this.gaugeChart = this.gaugeChart === undefined ? new GaugeChart({
      svg: svg,
      page: this.page,
      outerRadius: this.page === 'ExternalPage' ? 70 : 140,
      innerRadius: this.page === 'ExternalPage' ? 1 : 90
    }) : this.gaugeChart;

    this.gaugeChart.render();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value'] || changes['max']) {
      this.drawChart();
    }
  }

  drawChart() {
    if (this.intervalIndex) {
      clearInterval(this.intervalIndex);
    }
    this.intervalIndex = setInterval(() => {
      if (this.gaugeChart) {
        this.gaugeChart.reFillColor(this.data);
        this.value = this.value < this.min ? this.min : this.value > this.max ? this.max : this.value;
        const firstNumber = (this.value - this.min) / (this.max - this.min);
        this.gaugeChart.reFillColor(this.data);
        this.gaugeChart.animateTo(firstNumber, this.data);
        clearInterval(this.intervalIndex);
      }
    }, 200);
  }

  setPercentToRadian = (color) => {
    if (color === 'white') { return 0; }
    if (color === 'red') { return 16.65 / 100; }
    if (color === 'yellow') { return 50 / 100; }
    if (color === 'green') { return 83.35 / 100; }
  }


}
